import makeStyles from "@material-ui/styles/makeStyles";

const styles = makeStyles(theme => ({
	link: {
		color: "#B2B2B2",
		margin: theme.spacing(0, 1, 0, 0),
		display: "block",
		padding: theme.spacing(0.5, 0.5),
		"&:hover, &:focus": {
			color: "#FFFFFF"
		},
		[theme.breakpoints.down("md")]: {
			overflow: "hidden",
			textOverflow: "ellipsis",
			whiteSpace: "nowrap"
		},
		...theme?.customTypography?.footer?.metamenu
	},
	linkSelected: {
		color: "#FFFFFF"
	},
	icon: {
		marginRight: theme?.spacing(2)
	}
}));

export default styles;
